import { render, staticRenderFns } from "./MenuPreviewModal.vue?vue&type=template&id=1665caca&scoped=true&"
import script from "./MenuPreviewModal.vue?vue&type=script&lang=js&"
export * from "./MenuPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuPreviewModal.vue?vue&type=style&index=0&id=1665caca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1665caca",
  null
  
)

/* custom blocks */
import block0 from "./MenuPreviewModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VContainer,VDialog,VForm,VSelect})
